module.exports = __webpack_public_path__ + "static/img/news-img.d6ff52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news-img.png
// module id = zxtp
// module chunks = 3